const initialState = {
    processingUploadMassiveAssignment: false,
    successUploadMassiveAssignment: false,
    errorUploadMassiveAssignment: false,
    massiveAssignmentResult: null,
    processingUploadCancelAssignment: false,
    successUploadCancelAssignment: false,
    errorUploadCancelAssignment: false,
    resultCancelAssignment: null,
    processingGetAllAssignment: false,
    successGetAllAssignment: false,
    errorGetAllAssignment: false,
    allAssignmentData: null,
};
  
const assignOperatorReducer = (state = initialState, payload) => {
    switch (payload.type) {
        case "UPLOAD_MASSIVE_ASSIGNMENT_FILE_PROCESSING":
        return {
            ...state,
            processingUploadMassiveAssignment: true,
            successUploadMassiveAssignment: false,
            errorUploadMassiveAssignment: false,
        };
        case "UPLOAD_MASSIVE_ASSIGNMENT_FILE_SUCCESS":
        return {
            ...state,
            processingUploadMassiveAssignment: false,
            successUploadMassiveAssignment: true,
            errorUploadMassiveAssignment: false,
            massiveAssignmentResult: payload.value,
        };
        case "UPLOAD_MASSIVE_ASSIGNMENT_FILE_ERROR":
        return {
            ...state,
            processingUploadMassiveAssignment: false,
            successUploadMassiveAssignment: false,
            errorUploadMassiveAssignment: true,
        };
        case "UPLOAD_CANCEL_ASSIGNMENT_FILE_PROCESSING":
        return {
            ...state,
            processingUploadCancelAssignment: true,
            successUploadCancelAssignment: false,
            errorUploadCancelAssignment: false,
        };
        case "UPLOAD_CANCEL_ASSIGNMENT_FILE_SUCCESS":
        return {
            ...state,
            processingUploadCancelAssignment: false,
            successUploadCancelAssignment: true,
            errorUploadCancelAssignment: false,
            resultCancelAssignment: payload.value,
        };
        case "UPLOAD_CANCEL_ASSIGNMENT_FILE_ERROR":
        return {
            ...state,
            processingUploadCancelAssignment: false,
            successUploadCancelAssignment: false,
            errorUploadCancelAssignment: true,
        };
        case "RESET_CANCEL_ASSIGNMENT_FILE":
        return {
            ...state,
            resultCancelAssignment: [],
            successUploadCancelAssignment: false,
        };
        case "GET_ALL_ASSIGNMENT_PROCESSING":
        return {
            ...state,
            processingGetAllAssignment: true,
            successGetAllAssignment: false,
            errorGetAllAssignment: false,
            allAssignmentData: null,
        };
        case "GET_ALL_ASSIGNMENT_SUCCESS":
        return {
            ...state,
            processingGetAllAssignment: false,
            successGetAllAssignment: true,
            errorGetAllAssignment: false,
            allAssignmentData: payload.value,
        };
        case "GET_ALL_ASSIGNMENT_ERROR":
        return {
            ...state,
            processingGetAllAssignment: false,
            successGetAllAssignment: false,
            errorGetAllAssignment: true,
        };
        default:
        return state;
    }
};

export const assignOperatorActions = {
    UPLOAD_MASSIVE_ASSIGNMENT_FILE_PROCESSING: 'UPLOAD_MASSIVE_ASSIGNMENT_FILE_PROCESSING',
    UPLOAD_MASSIVE_ASSIGNMENT_FILE_SUCCESS: 'UPLOAD_MASSIVE_ASSIGNMENT_FILE_SUCCESS',
    UPLOAD_MASSIVE_ASSIGNMENT_FILE_ERROR: 'UPLOAD_MASSIVE_ASSIGNMENT_FILE_ERROR',
    UPLOAD_CANCEL_ASSIGNMENT_FILE_PROCESSING: 'UPLOAD_CANCEL_ASSIGNMENT_FILE_PROCESSING',
    UPLOAD_CANCEL_ASSIGNMENT_FILE_SUCCESS: 'UPLOAD_CANCEL_ASSIGNMENT_FILE_SUCCESS',
    UPLOAD_CANCEL_ASSIGNMENT_FILE_ERROR: 'UPLOAD_CANCEL_ASSIGNMENT_FILE_ERROR',
    GET_ALL_ASSIGNMENT_REQUEST: 'GET_ALL_ASSIGNMENT_REQUEST',
    GET_ALL_ASSIGNMENT_PROCESSING: 'GET_ALL_ASSIGNMENT_PROCESSING',
    GET_ALL_ASSIGNMENT_SUCCESS: 'GET_ALL_ASSIGNMENT_SUCCESS',
    GET_ALL_ASSIGNMENT_ERROR: 'GET_ALL_ASSIGNMENT_ERROR',
}

export default assignOperatorReducer;